import ShowModulePercentage from '../../../ModuleCardNew/ShowModulePercentage';
import ModuleCardActions from '../../../ModuleCardNew/moduleFace/ModuleCardActions';

const DURATION_LABELS = {
    'isReady': 'Is Ready',
    '1 mins': '1 Min',
    '2 mins': '2 Mins',
    '3mins': '3 Mins',
    '5mins': '5 Mins',
    '10mins': '10 Mins',
    '15mins': '15 Mins',
    '30mins': '30 Mins',
    '2 days': '2 Days',
};

const ModuleCardPreview = ({ moduleData }) => {
    const defaultLogo = require('../../../../../images/icon.png');

    const tagHex = typeof moduleData?.moduleTagColor === 'string' ? moduleData.moduleTagColor.trim() : '';
    const hasValidTagHex = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6})$/.test(tagHex);

    const getModuleImage = () => {
        if (moduleData?.imageURL) {
            return moduleData.imageURL;
        }
        return defaultLogo;
    };

    // Create a mock module object for ShowModulePercentage
    const mockModule = {
        stats: {
            completionPercent: 0,
            riskPercent: 0
        }
    };

    // Determine if we should show risk percentage (exclude certain modules)
    const shouldShowRisk = !['Data Repository', 'InvestorMatch'].includes(moduleData?.moduleName);

    // For preview, use the module name directly or a default
    const moduleName = moduleData?.moduleName || 'Module Name';
    const logoAlt = moduleData?.moduleName || 'Module Logo';
    const durationLabel = moduleData?.duration && moduleData.duration !== 'NIL'
        ? (DURATION_LABELS[moduleData.duration] || null)
        : null;

    return (
        <div
            className='br20px bg1 p1-5rem new-shadow df fdc aisb jcsb pr'
            style={{ height: '200px', maxWidth: '350px', minWidth: 0 }}
        >
            {/* Three dots menu placeholder (non-interactive) */}
            <div className="ds-module-menu" style={{ opacity: 0.5, pointerEvents: 'none' }}>
                <div className="ds-module-card__menu">•••</div>
            </div>

            <div className='df fdc aisb jcsb h100'>
                <div className='df aic w100'>
                    <div className='br10px bg1 p0-5rem bo77 bss bw1px df aic jcc' style={{ width: '64px', height: '64px' }}>
                        <img
                            src={getModuleImage()}
                            alt={logoAlt}
                            width={52}
                            height={47}
                            onError={(e) => {
                                e.target.src = defaultLogo;
                            }}
                            style={{
                                objectFit: 'cover',
                                borderRadius: '4px'
                            }}
                        />
                    </div>
                    <div className='df aic jcfs pr'>
                        {moduleData?.moduleSubTitle ? (
                            <p
                                className={`fs12px fw400 pa ${hasValidTagHex ? '' : 'c15 op70'}`}
                                style={{
                                    left: '1rem',
                                    top: '-14px',
                                    ...(hasValidTagHex ? { color: tagHex } : {})
                                }}
                            >
                                {moduleData.moduleSubTitle.length > 30
                                    ? moduleData.moduleSubTitle.substring(0, 30) + '...'
                                    : moduleData.moduleSubTitle}
                            </p>
                        ) : null}
                        <p className='fs15px fw500 c15 ml1rem'>{moduleName}</p>
                    </div>
                </div>

                <div className='w100 df aife jcsb' style={{ gap: '0.5rem' }}>
                    <div className='df jcfs aic'>
                        <ShowModulePercentage value={mockModule?.stats?.completionPercent || 0} type="Module Complete" />
                        {shouldShowRisk && (
                            <ShowModulePercentage value={mockModule?.stats?.riskPercent || 0} type="Module Risk" />
                        )}
                    </div>

                    <ModuleCardActions
                        durationLabel={durationLabel}
                        isPaid={!!moduleData?.isPaid}
                        onBuyClick={() => {}}
                    />
                </div>
            </div>
        </div>
    );
};

export default ModuleCardPreview;

